module.exports = __webpack_public_path__ + "img/mardelplata_winter.453a93a7.svg";